<template>
    <div class="helpPayForDetail">
        <!-- 支付成功 -->
        <div class="success-img" v-if="payForStatus==0">
            <img src="../../assets/images/zhifuchenggong.png" alt="">
        </div>
        <!-- 支付失败 -->
        <div class="success-img" v-else-if="payForStatus==1">
            <img src="../../assets/images/zhifushibai.png" alt="">
        </div>
        <!-- 支付成功 -->
        <div class="success-text" v-if="payForStatus==0">支付成功</div>
        <div class="faile-text" v-if="payForStatus==1">支付失败，请重新支付</div>
        <div class="pay-for-money-price-con" v-if="payForStatus==0">
            <div class="pay-for-money-before">￥</div>
            <div class="pay-for-money-price">{{payForMoney}}</div>
        </div>
        <div class="already" @click="toStudy">完成</div>
    </div>
</template>
<script>
import api from "../../api/api";

    export default {
        name: 'helpPayForDetail',
        data() {
            return {
                payForMoney: '0',
                payForStatus: 0,//支付成功
                // payForStatus:1,//支付失败
                preOrderId: 0//预支付订单 查询支付价格
            }
        },
        methods: {
            toStudy() {
                //   无论是支付成功还是失败点击完成都跳转到店铺页面
                // console.log('跳转到店铺页面')
                try {
                    // wx.miniProgram.switchTab({url:"/pages/switchPage"});
                    wx.miniProgram.redirectTo({url:"../../switchPage?into=0&flag=normal"});
                } catch (error) {
                    throw error;
                }
            },
            //查询预支付订单
            getPreOrderMsg(){
                let params = {
                    id:this.preOrderId
                }
                api.getPreOrderMsg(params).then(res=>{
                    console.log("查询成功 ",res.data)
                    this.payForMoney = res.data.product.promotionPriceStr;
                }).catch(err=>{

                })
            }
        },
        created() {
            document.title = "支付详情";
            this.payForStatus = this.$route.params.payForStatus;
            console.log("状态",this.$route.params.payForStatus)
            if (this.payForStatus === '0' || this.payForStatus === 0){
                console.log("查询订单")
                this.preOrderId = this.$route.params.preOrderId;
                this.getPreOrderMsg()
            }
        }
    }
</script>
<style lang="scss">
    html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        background: #F8F8F8;
    }

    .helpPayForDetail {
        width: 100%;
        height: 100%;
        // 支付成功 
        .success-img {
            width: 163px;
            height: 150px;
            padding-top: 84px;
            margin: 0 auto;

            img {
                width: 163px;
                height: 150px;
            }
        }

        .success-text {
            width: 56px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin: 0 auto;
            padding-top: 14px;
            padding-bottom: 10px;
        }

        .faile-text {
            width: 140px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF6060;
            line-height: 20px;
            margin: 0 auto;
            padding-top: 14px;
            padding-bottom: 121px;
        }

        .erweima-text {
            width: 84px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF6060;
            line-height: 20px;
            margin: 0 auto;
            padding-top: 14px;
            padding-bottom: 12px;
        }

        .erweima-tips {
            width: 266px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin: 0 auto;
            padding-bottom: 89px;
        }

        .pay-for-money-price-con {
            display: flex;
            // margin: 0 auto;
            // width: 90px;
            justify-content: center;
            align-items: center;
            height: 28px;
            padding-bottom: 83px;

            .pay-for-money-before {
                // width: 20px;
                // height: 20px;
                line-height: 28px;
                font-size: 18px;
                color: #333333;
                padding: 2px 0px 0px 0px;
                font-weight: 600;

            }

            .pay-for-money-price {
                // width: 66px;
                height: 28px;
                line-height: 28px;
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 28px;
                font-weight: bold;
            }
        }

        // 完成
        .already {
            width: 299px;
            height: 49px;
            background: linear-gradient(315deg, #FF6060 0%, #FB6460 100%);
            border-radius: 25px;
            margin: 0 auto;
            line-height: 49px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
        }
    }
</style>

